<template>
  <section id="contact">
    <b-container class="text-center">
      <b-row>
        <b-col>
          <h1>Pitch us</h1>
        </b-col>
      </b-row>

      <b-row class="pitch">
        <b-col md="5">
          <p>Apply for the Tachi.ai15 fast track</p>
          <router-link to="/tachi15">
            <app-button class="red-button" href="#">Learn More</app-button>
          </router-link>
        </b-col>
        <b-col md="2">
          <p class="or">OR</p>
        </b-col>
        <b-col md="5">
          <p>Send us your pitch deck directly</p>
          <app-button class="red-button" href="mailto:pitch@tachi.ai"
            >Send pitch</app-button
          >
        </b-col>
      </b-row>

      <b-row v-if="false">
        <b-col md="4">
          <img :src="require(`../assets/${image15[index % 3]}`)" />
        </b-col>
        <b-col md="4">
          <img src="../assets/logo.png" />
        </b-col>
        <b-col md="4">
          <img :src="require(`../assets/${image15[index % 3]}`)" />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import RedButton from "./Reusable/RedButton.vue";
import { setInterval } from "timers";
export default {
  data() {
    return {
      image15: ["15M-¥.png", "15-days.png", "15.png"],
      currentImage15: false,
      index: 0
    };
  },
  created() {
    setInterval(() => {
      this.index++;
    }, 1000);
  },
  components: {
    "app-button": RedButton
  }
};
</script>

<style>
#contact {
  background: url("../assets/lanterns.jpg") center no-repeat fixed;
  background-size: cover;
  height: auto;
  color: white;
  padding-bottom: 2rem;
}

#contact h1 {
  margin-top: 10%;
  color: white;
  font-weight: 700;
  font-size: 4rem;
  text-shadow: 0.1rem 0.1rem 0.8rem black;
}

#contact .red-button {
  margin: 50px;
}

#contact img {
  height: 20rem;
  padding: 5%;
}

#contact .pitch {
  margin-top: 50px;
  padding: 30px 0;
}
#contact .pitch p {
  font-size: 1.5em;
}
#contact .pitch .or {
  font-size: 2em;
  font-weight: 700;
}
</style>